/* First Pace — v2 interactions: scroll reveal, marquee, sticky buy bar */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var AUTO = ['.fp-benefit', '.fp-step', '.fp-use', '.fp-split__content', '.fp-split__media', '.fp-spot__info', '.fp-spot__gallery', '.fp-faq__item', '.fp-intro__inner', '.fp-head'];

  function autoReveal(root) {
    var scope = root || document;
    AUTO.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (el) {
        if (!el.classList.contains('fp-reveal') && !el.hasAttribute('data-revealed')) el.classList.add('fp-reveal');
      });
    });
  }

  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('.fp-reveal:not([data-revealed])');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); n.setAttribute('data-revealed', ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var index = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--fp-d', Math.min(index, 6) * 70 + 'ms');
        el.classList.add('is-in');
        el.setAttribute('data-revealed', '');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function initMarquee(root) {
    (root || document).querySelectorAll('.fp-marq__track:not([data-cloned])').forEach(function (track) {
      var group = track.querySelector('.fp-marq__group');
      if (!group) return;
      track.appendChild(group.cloneNode(true));
      track.setAttribute('data-cloned', '');
    });
  }

  function initSticky(root) {
    (root || document).querySelectorAll('.fp-sticky:not([data-init])').forEach(function (bar) {
      bar.setAttribute('data-init', '');
      var sel = bar.getAttribute('data-after');
      var anchor = sel ? document.querySelector(sel) : null;
      var footer = document.querySelector('footer');
      function update() {
        var past = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
        var atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
        bar.classList.toggle('is-visible', past && !atFooter);
      }
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  function initAll(root) { autoReveal(root); initReveal(root); initMarquee(root); initSticky(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();